<template>
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.584 26.6836C23.584 15.6541 32.5252 6.71289 43.5547 6.71289C54.5842 6.71289 63.5254 15.6541 63.5254 26.6836V44.0664H54.9316V26.6836C54.9316 20.4003 49.838 15.3066 43.5547 15.3066C37.2714 15.3066 32.1777 20.4003 32.1777 26.6836V44.0664H23.584V26.6836Z"
      fill="#C2C2C6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.584 26.6836C23.584 15.6541 32.5252 6.71289 43.5547 6.71289C54.5842 6.71289 63.5254 15.6541 63.5254 26.6836V44.0664H54.9316V26.6836C54.9316 20.4003 49.838 15.3066 43.5547 15.3066C37.2714 15.3066 32.1777 20.4003 32.1777 26.6836V44.0664H23.584V26.6836Z"
      fill="url(#paint0_linear_8514_64335)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.584 26.6836C23.584 15.6541 32.5252 6.71289 43.5547 6.71289C54.5842 6.71289 63.5254 15.6541 63.5254 26.6836V44.0664H54.9316V26.6836C54.9316 20.4003 49.838 15.3066 43.5547 15.3066C37.2714 15.3066 32.1777 20.4003 32.1777 26.6836V44.0664H23.584V26.6836Z"
      fill="url(#paint1_linear_8514_64335)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.584 26.6836C23.584 15.6541 32.5252 6.71289 43.5547 6.71289C54.5842 6.71289 63.5254 15.6541 63.5254 26.6836V44.0664H54.9316V26.6836C54.9316 20.4003 49.838 15.3066 43.5547 15.3066C37.2714 15.3066 32.1777 20.4003 32.1777 26.6836V44.0664H23.584V26.6836Z"
      fill="url(#paint2_linear_8514_64335)"
      fill-opacity="0.39"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.584 26.6836C23.584 15.6541 32.5252 6.71289 43.5547 6.71289C54.5842 6.71289 63.5254 15.6541 63.5254 26.6836V44.0664H54.9316V26.6836C54.9316 20.4003 49.838 15.3066 43.5547 15.3066C37.2714 15.3066 32.1777 20.4003 32.1777 26.6836V44.0664H23.584V26.6836Z"
      fill="url(#paint3_radial_8514_64335)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.584 26.6836C23.584 15.6541 32.5252 6.71289 43.5547 6.71289C54.5842 6.71289 63.5254 15.6541 63.5254 26.6836V44.0664H54.9316V26.6836C54.9316 20.4003 49.838 15.3066 43.5547 15.3066C37.2714 15.3066 32.1777 20.4003 32.1777 26.6836V44.0664H23.584V26.6836Z"
      fill="url(#paint4_radial_8514_64335)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.584 26.6836C23.584 15.6541 32.5252 6.71289 43.5547 6.71289C54.5842 6.71289 63.5254 15.6541 63.5254 26.6836V44.0664H54.9316V26.6836C54.9316 20.4003 49.838 15.3066 43.5547 15.3066C37.2714 15.3066 32.1777 20.4003 32.1777 26.6836V44.0664H23.584V26.6836Z"
      fill="url(#paint5_radial_8514_64335)"
      fill-opacity="0.3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.584 26.6836C23.584 15.6541 32.5252 6.71289 43.5547 6.71289C54.5842 6.71289 63.5254 15.6541 63.5254 26.6836V44.0664H54.9316V26.6836C54.9316 20.4003 49.838 15.3066 43.5547 15.3066C37.2714 15.3066 32.1777 20.4003 32.1777 26.6836V44.0664H23.584V26.6836Z"
      fill="url(#paint6_radial_8514_64335)"
      fill-opacity="0.3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.584 26.6836C23.584 15.6541 32.5252 6.71289 43.5547 6.71289C54.5842 6.71289 63.5254 15.6541 63.5254 26.6836V44.0664H54.9316V26.6836C54.9316 20.4003 49.838 15.3066 43.5547 15.3066C37.2714 15.3066 32.1777 20.4003 32.1777 26.6836V44.0664H23.584V26.6836Z"
      fill="url(#paint7_radial_8514_64335)"
      fill-opacity="0.3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.584 26.6836C23.584 15.6541 32.5252 6.71289 43.5547 6.71289C54.5842 6.71289 63.5254 15.6541 63.5254 26.6836V44.0664H54.9316V26.6836C54.9316 20.4003 49.838 15.3066 43.5547 15.3066C37.2714 15.3066 32.1777 20.4003 32.1777 26.6836V44.0664H23.584V26.6836Z"
      fill="url(#paint8_radial_8514_64335)"
      fill-opacity="0.3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.584 26.6836C23.584 15.6541 32.5252 6.71289 43.5547 6.71289C54.5842 6.71289 63.5254 15.6541 63.5254 26.6836V44.0664H54.9316V26.6836C54.9316 20.4003 49.838 15.3066 43.5547 15.3066C37.2714 15.3066 32.1777 20.4003 32.1777 26.6836V44.0664H23.584V26.6836Z"
      fill="url(#paint9_radial_8514_64335)"
      fill-opacity="0.3"
    />
    <rect
      x="9.375"
      y="34.6426"
      width="68.5547"
      height="58.8867"
      rx="9.375"
      fill="url(#paint10_linear_8514_64335)"
    />
    <rect
      x="9.375"
      y="34.6426"
      width="68.5547"
      height="58.8867"
      rx="9.375"
      fill="url(#paint11_radial_8514_64335)"
    />
    <rect
      x="9.375"
      y="34.6426"
      width="68.5547"
      height="58.8867"
      rx="9.375"
      fill="url(#paint12_linear_8514_64335)"
    />
    <rect
      x="9.375"
      y="34.6426"
      width="68.5547"
      height="58.8867"
      rx="9.375"
      fill="url(#paint13_linear_8514_64335)"
    />
    <rect
      x="9.375"
      y="34.6426"
      width="68.5547"
      height="58.8867"
      rx="9.375"
      fill="url(#paint14_linear_8514_64335)"
    />
    <rect
      x="9.375"
      y="34.6426"
      width="68.5547"
      height="58.8867"
      rx="9.375"
      fill="url(#paint15_linear_8514_64335)"
    />
    <rect
      x="9.375"
      y="34.6426"
      width="68.5547"
      height="58.8867"
      rx="9.375"
      fill="url(#paint16_linear_8514_64335)"
    />
    <rect
      x="9.375"
      y="34.6426"
      width="68.5547"
      height="58.8867"
      rx="9.375"
      fill="url(#paint17_linear_8514_64335)"
    />
    <rect
      x="9.375"
      y="34.6426"
      width="68.5547"
      height="58.8867"
      rx="9.375"
      fill="url(#paint18_linear_8514_64335)"
    />
    <rect
      x="9.375"
      y="34.6426"
      width="68.5547"
      height="58.8867"
      rx="9.375"
      fill="url(#paint19_radial_8514_64335)"
    />
    <rect
      x="9.375"
      y="34.6426"
      width="68.5547"
      height="58.8867"
      rx="9.375"
      fill="url(#paint20_linear_8514_64335)"
    />
    <rect
      x="9.375"
      y="34.6426"
      width="68.5547"
      height="58.8867"
      rx="9.375"
      fill="url(#paint21_linear_8514_64335)"
    />
    <rect
      x="9.375"
      y="34.6426"
      width="68.5547"
      height="58.8867"
      rx="9.375"
      fill="url(#paint22_linear_8514_64335)"
    />
    <rect
      x="9.375"
      y="34.6426"
      width="68.5547"
      height="58.8867"
      rx="9.375"
      fill="url(#paint23_linear_8514_64335)"
    />
    <rect
      x="9.375"
      y="34.6426"
      width="68.5547"
      height="58.8867"
      rx="9.375"
      fill="url(#paint24_linear_8514_64335)"
    />
    <rect
      x="9.375"
      y="34.6426"
      width="68.5547"
      height="58.8867"
      rx="9.375"
      fill="url(#paint25_linear_8514_64335)"
    />
    <rect
      x="9.375"
      y="34.6426"
      width="68.5547"
      height="58.8867"
      rx="9.375"
      fill="url(#paint26_linear_8514_64335)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M43.6096 55.0713C42.5612 55.0713 41.7114 55.9211 41.7114 56.9695C41.7114 57.6405 42.0552 58.2361 42.6061 58.5821L43.6235 59.221L44.633 58.5694C45.1727 58.221 45.5078 57.6325 45.5078 56.9695C45.5078 55.9211 44.658 55.0713 43.6096 55.0713ZM29.2114 56.9695C29.2114 49.0176 35.6576 42.5713 43.6096 42.5713C51.5616 42.5713 58.0078 49.0176 58.0078 56.9695C58.0078 60.6973 56.5885 64.0916 54.2725 66.6438V74.1693C54.2725 80.0346 49.5177 84.7894 43.6523 84.7894C37.787 84.7894 33.0322 80.0346 33.0322 74.1693V66.7371C30.6655 64.1745 29.2114 60.7431 29.2114 56.9695Z"
      fill="url(#paint27_radial_8514_64335)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M43.6096 55.0713C42.5612 55.0713 41.7114 55.9211 41.7114 56.9695C41.7114 57.6405 42.0552 58.2361 42.6061 58.5821L43.6235 59.221L44.633 58.5694C45.1727 58.221 45.5078 57.6325 45.5078 56.9695C45.5078 55.9211 44.658 55.0713 43.6096 55.0713ZM29.2114 56.9695C29.2114 49.0176 35.6576 42.5713 43.6096 42.5713C51.5616 42.5713 58.0078 49.0176 58.0078 56.9695C58.0078 60.6973 56.5885 64.0916 54.2725 66.6438V74.1693C54.2725 80.0346 49.5177 84.7894 43.6523 84.7894C37.787 84.7894 33.0322 80.0346 33.0322 74.1693V66.7371C30.6655 64.1745 29.2114 60.7431 29.2114 56.9695Z"
      fill="url(#paint28_radial_8514_64335)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M43.6096 55.0713C42.5612 55.0713 41.7114 55.9211 41.7114 56.9695C41.7114 57.6405 42.0552 58.2361 42.6061 58.5821L43.6235 59.221L44.633 58.5694C45.1727 58.221 45.5078 57.6325 45.5078 56.9695C45.5078 55.9211 44.658 55.0713 43.6096 55.0713ZM29.2114 56.9695C29.2114 49.0176 35.6576 42.5713 43.6096 42.5713C51.5616 42.5713 58.0078 49.0176 58.0078 56.9695C58.0078 60.6973 56.5885 64.0916 54.2725 66.6438V74.1693C54.2725 80.0346 49.5177 84.7894 43.6523 84.7894C37.787 84.7894 33.0322 80.0346 33.0322 74.1693V66.7371C30.6655 64.1745 29.2114 60.7431 29.2114 56.9695Z"
      fill="url(#paint29_radial_8514_64335)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M43.6096 55.0713C42.5612 55.0713 41.7114 55.9211 41.7114 56.9695C41.7114 57.6405 42.0552 58.2361 42.6061 58.5821L43.6235 59.221L44.633 58.5694C45.1727 58.221 45.5078 57.6325 45.5078 56.9695C45.5078 55.9211 44.658 55.0713 43.6096 55.0713ZM29.2114 56.9695C29.2114 49.0176 35.6576 42.5713 43.6096 42.5713C51.5616 42.5713 58.0078 49.0176 58.0078 56.9695C58.0078 60.6973 56.5885 64.0916 54.2725 66.6438V74.1693C54.2725 80.0346 49.5177 84.7894 43.6523 84.7894C37.787 84.7894 33.0322 80.0346 33.0322 74.1693V66.7371C30.6655 64.1745 29.2114 60.7431 29.2114 56.9695Z"
      fill="url(#paint30_radial_8514_64335)"
    />
    <path
      d="M48.0225 63.8205C50.2699 62.3699 51.7578 59.8434 51.7578 56.9695C51.7578 52.4694 48.1098 48.8213 43.6096 48.8213C39.1094 48.8213 35.4614 52.4694 35.4614 56.9695C35.4614 59.8797 36.9871 62.4336 39.2822 63.8749V74.1693C39.2822 76.5828 41.2388 78.5394 43.6523 78.5394C46.0659 78.5394 48.0225 76.5828 48.0225 74.1693V63.8205Z"
      fill="url(#paint31_radial_8514_64335)"
    />
    <path
      d="M57.5691 34.6436C57.4205 35.4756 56.9885 37.7916 56.9885 38.6664C56.9885 44.6803 60.6554 49.8377 65.8752 52.0249V60.9048C65.8752 61.5534 66.1274 62.1767 66.5783 62.643L67.8864 63.9951C68.3096 64.4324 68.5364 65.0232 68.5146 65.6313C68.4971 66.1225 68.3184 66.5942 68.0061 66.9737L67.3822 67.7319C67.071 68.1104 66.9006 68.5852 66.9006 69.0753C66.9006 69.5565 67.0649 70.0233 67.366 70.3986L67.9762 71.159C68.3071 71.5715 68.4875 72.0845 68.4875 72.6134C68.4875 73.2599 68.2182 73.8772 67.7443 74.3169L66.675 75.309C66.165 75.7821 65.8752 76.4462 65.8752 77.1417V81.9281C65.8752 85.0293 68.8356 92.7979 71.9368 92.7979C72.7087 92.7979 75.1418 90.9034 75.5501 90.3931C75.9407 89.9048 77.4422 88.269 77.7962 85.6146L77.4758 45.4779C77.4758 40.3002 72.8764 34.6436 67.6987 34.6436H57.5691Z"
      fill="url(#paint32_radial_8514_64335)"
    />
    <path
      d="M57.5691 34.6436C57.4205 35.4756 56.9885 37.7916 56.9885 38.6664C56.9885 44.6803 60.6554 49.8377 65.8752 52.0249V60.9048C65.8752 61.5534 66.1274 62.1767 66.5783 62.643L67.8864 63.9951C68.3096 64.4324 68.5364 65.0232 68.5146 65.6313C68.4971 66.1225 68.3184 66.5942 68.0061 66.9737L67.3822 67.7319C67.071 68.1104 66.9006 68.5852 66.9006 69.0753C66.9006 69.5565 67.0649 70.0233 67.366 70.3986L67.9762 71.159C68.3071 71.5715 68.4875 72.0845 68.4875 72.6134C68.4875 73.2599 68.2182 73.8772 67.7443 74.3169L66.675 75.309C66.165 75.7821 65.8752 76.4462 65.8752 77.1417V81.9281C65.8752 85.0293 68.8356 92.7979 71.9368 92.7979C72.7087 92.7979 75.1418 90.9034 75.5501 90.3931C75.9407 89.9048 77.4422 88.269 77.7962 85.6146L77.4758 45.4779C77.4758 40.3002 72.8764 34.6436 67.6987 34.6436H57.5691Z"
      fill="url(#paint33_radial_8514_64335)"
    />
    <path
      d="M57.5691 34.6436C57.4205 35.4756 56.9885 37.7916 56.9885 38.6664C56.9885 44.6803 60.6554 49.8377 65.8752 52.0249V60.9048C65.8752 61.5534 66.1274 62.1767 66.5783 62.643L67.8864 63.9951C68.3096 64.4324 68.5364 65.0232 68.5146 65.6313C68.4971 66.1225 68.3184 66.5942 68.0061 66.9737L67.3822 67.7319C67.071 68.1104 66.9006 68.5852 66.9006 69.0753C66.9006 69.5565 67.0649 70.0233 67.366 70.3986L67.9762 71.159C68.3071 71.5715 68.4875 72.0845 68.4875 72.6134C68.4875 73.2599 68.2182 73.8772 67.7443 74.3169L66.675 75.309C66.165 75.7821 65.8752 76.4462 65.8752 77.1417V81.9281C65.8752 85.0293 68.8356 92.7979 71.9368 92.7979C72.7087 92.7979 75.1418 90.9034 75.5501 90.3931C75.9407 89.9048 77.4422 88.269 77.7962 85.6146L77.4758 45.4779C77.4758 40.3002 72.8764 34.6436 67.6987 34.6436H57.5691Z"
      fill="url(#paint34_radial_8514_64335)"
      fill-opacity="0.62"
    />
    <path
      d="M57.5691 34.6436C57.4205 35.4756 56.9885 37.7916 56.9885 38.6664C56.9885 44.6803 60.6554 49.8377 65.8752 52.0249V60.9048C65.8752 61.5534 66.1274 62.1767 66.5783 62.643L67.8864 63.9951C68.3096 64.4324 68.5364 65.0232 68.5146 65.6313C68.4971 66.1225 68.3184 66.5942 68.0061 66.9737L67.3822 67.7319C67.071 68.1104 66.9006 68.5852 66.9006 69.0753C66.9006 69.5565 67.0649 70.0233 67.366 70.3986L67.9762 71.159C68.3071 71.5715 68.4875 72.0845 68.4875 72.6134C68.4875 73.2599 68.2182 73.8772 67.7443 74.3169L66.675 75.309C66.165 75.7821 65.8752 76.4462 65.8752 77.1417V81.9281C65.8752 85.0293 68.8356 92.7979 71.9368 92.7979C72.7087 92.7979 75.1418 90.9034 75.5501 90.3931C75.9407 89.9048 77.4422 88.269 77.7962 85.6146L77.4758 45.4779C77.4758 40.3002 72.8764 34.6436 67.6987 34.6436H57.5691Z"
      fill="url(#paint35_radial_8514_64335)"
    />
    <path
      d="M57.5691 34.6436C57.4205 35.4756 56.9885 37.7916 56.9885 38.6664C56.9885 44.6803 60.6554 49.8377 65.8752 52.0249V60.9048C65.8752 61.5534 66.1274 62.1767 66.5783 62.643L67.8864 63.9951C68.3096 64.4324 68.5364 65.0232 68.5146 65.6313C68.4971 66.1225 68.3184 66.5942 68.0061 66.9737L67.3822 67.7319C67.071 68.1104 66.9006 68.5852 66.9006 69.0753C66.9006 69.5565 67.0649 70.0233 67.366 70.3986L67.9762 71.159C68.3071 71.5715 68.4875 72.0845 68.4875 72.6134C68.4875 73.2599 68.2182 73.8772 67.7443 74.3169L66.675 75.309C66.165 75.7821 65.8752 76.4462 65.8752 77.1417V81.9281C65.8752 85.0293 68.8356 92.7979 71.9368 92.7979C72.7087 92.7979 75.1418 90.9034 75.5501 90.3931C75.9407 89.9048 77.4422 88.269 77.7962 85.6146L77.4758 45.4779C77.4758 40.3002 72.8764 34.6436 67.6987 34.6436H57.5691Z"
      fill="url(#paint36_radial_8514_64335)"
    />
    <path
      d="M57.5691 34.6436C57.4205 35.4756 56.9885 37.7916 56.9885 38.6664C56.9885 44.6803 60.6554 49.8377 65.8752 52.0249V60.9048C65.8752 61.5534 66.1274 62.1767 66.5783 62.643L67.8864 63.9951C68.3096 64.4324 68.5364 65.0232 68.5146 65.6313C68.4971 66.1225 68.3184 66.5942 68.0061 66.9737L67.3822 67.7319C67.071 68.1104 66.9006 68.5852 66.9006 69.0753C66.9006 69.5565 67.0649 70.0233 67.366 70.3986L67.9762 71.159C68.3071 71.5715 68.4875 72.0845 68.4875 72.6134C68.4875 73.2599 68.2182 73.8772 67.7443 74.3169L66.675 75.309C66.165 75.7821 65.8752 76.4462 65.8752 77.1417V81.9281C65.8752 85.0293 68.8356 92.7979 71.9368 92.7979C72.7087 92.7979 75.1418 90.9034 75.5501 90.3931C75.9407 89.9048 77.4422 88.269 77.7962 85.6146L77.4758 45.4779C77.4758 40.3002 72.8764 34.6436 67.6987 34.6436H57.5691Z"
      fill="url(#paint37_radial_8514_64335)"
    />
    <path
      d="M57.5691 34.6436C57.4205 35.4756 56.9885 37.7916 56.9885 38.6664C56.9885 44.6803 60.6554 49.8377 65.8752 52.0249V60.9048C65.8752 61.5534 66.1274 62.1767 66.5783 62.643L67.8864 63.9951C68.3096 64.4324 68.5364 65.0232 68.5146 65.6313C68.4971 66.1225 68.3184 66.5942 68.0061 66.9737L67.3822 67.7319C67.071 68.1104 66.9006 68.5852 66.9006 69.0753C66.9006 69.5565 67.0649 70.0233 67.366 70.3986L67.9762 71.159C68.3071 71.5715 68.4875 72.0845 68.4875 72.6134C68.4875 73.2599 68.2182 73.8772 67.7443 74.3169L66.675 75.309C66.165 75.7821 65.8752 76.4462 65.8752 77.1417V81.9281C65.8752 85.0293 68.8356 92.7979 71.9368 92.7979C72.7087 92.7979 75.1418 90.9034 75.5501 90.3931C75.9407 89.9048 77.4422 88.269 77.7962 85.6146L77.4758 45.4779C77.4758 40.3002 72.8764 34.6436 67.6987 34.6436H57.5691Z"
      fill="url(#paint38_radial_8514_64335)"
      fill-opacity="0.8"
    />
    <path
      d="M57.5691 34.6436C57.4205 35.4756 56.9885 37.7916 56.9885 38.6664C56.9885 44.6803 60.6554 49.8377 65.8752 52.0249V60.9048C65.8752 61.5534 66.1274 62.1767 66.5783 62.643L67.8864 63.9951C68.3096 64.4324 68.5364 65.0232 68.5146 65.6313C68.4971 66.1225 68.3184 66.5942 68.0061 66.9737L67.3822 67.7319C67.071 68.1104 66.9006 68.5852 66.9006 69.0753C66.9006 69.5565 67.0649 70.0233 67.366 70.3986L67.9762 71.159C68.3071 71.5715 68.4875 72.0845 68.4875 72.6134C68.4875 73.2599 68.2182 73.8772 67.7443 74.3169L66.675 75.309C66.165 75.7821 65.8752 76.4462 65.8752 77.1417V81.9281C65.8752 85.0293 68.8356 92.7979 71.9368 92.7979C72.7087 92.7979 75.1418 90.9034 75.5501 90.3931C75.9407 89.9048 77.4422 88.269 77.7962 85.6146L77.4758 45.4779C77.4758 40.3002 72.8764 34.6436 67.6987 34.6436H57.5691Z"
      fill="url(#paint39_radial_8514_64335)"
      fill-opacity="0.8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M84.1919 50.9357C89.3858 48.7368 93.0298 43.5928 93.0298 37.5977C93.0298 29.6019 86.548 23.1201 78.5522 23.1201C70.5564 23.1201 64.0747 29.6019 64.0747 37.5977C64.0747 43.6116 67.7415 48.769 72.9614 50.9562V59.836C72.9614 60.4847 73.2136 61.108 73.6646 61.5742L74.9725 62.9263C75.3958 63.3637 75.6226 63.9545 75.6008 64.5626C75.5833 65.0537 75.4045 65.5254 75.0923 65.9049L74.4684 66.6632C74.1571 67.0416 73.9868 67.5165 73.9868 68.0065C73.9868 68.4877 74.151 68.9545 74.4522 69.3298L75.0624 70.0903C75.3933 70.5027 75.5737 71.0158 75.5737 71.5446C75.5737 72.1912 75.3044 72.8085 74.8304 73.2482L73.7611 74.2402C73.2512 74.7133 72.9614 75.3774 72.9614 76.073V80.8594C72.9614 83.9606 75.4755 86.4746 78.5767 86.4746C81.6778 86.4746 84.1919 83.9606 84.1919 80.8594V50.9357ZM81.7993 30.1025C81.7993 31.8959 80.3455 33.3496 78.5522 33.3496C76.759 33.3496 75.3052 31.8959 75.3052 30.1025C75.3052 28.3092 76.759 26.8555 78.5522 26.8555C80.3455 26.8555 81.7993 28.3092 81.7993 30.1025Z"
      fill="#CDC1DE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M84.1919 50.9357C89.3858 48.7368 93.0298 43.5928 93.0298 37.5977C93.0298 29.6019 86.548 23.1201 78.5522 23.1201C70.5564 23.1201 64.0747 29.6019 64.0747 37.5977C64.0747 43.6116 67.7415 48.769 72.9614 50.9562V59.836C72.9614 60.4847 73.2136 61.108 73.6646 61.5742L74.9725 62.9263C75.3958 63.3637 75.6226 63.9545 75.6008 64.5626C75.5833 65.0537 75.4045 65.5254 75.0923 65.9049L74.4684 66.6632C74.1571 67.0416 73.9868 67.5165 73.9868 68.0065C73.9868 68.4877 74.151 68.9545 74.4522 69.3298L75.0624 70.0903C75.3933 70.5027 75.5737 71.0158 75.5737 71.5446C75.5737 72.1912 75.3044 72.8085 74.8304 73.2482L73.7611 74.2402C73.2512 74.7133 72.9614 75.3774 72.9614 76.073V80.8594C72.9614 83.9606 75.4755 86.4746 78.5767 86.4746C81.6778 86.4746 84.1919 83.9606 84.1919 80.8594V50.9357ZM81.7993 30.1025C81.7993 31.8959 80.3455 33.3496 78.5522 33.3496C76.759 33.3496 75.3052 31.8959 75.3052 30.1025C75.3052 28.3092 76.759 26.8555 78.5522 26.8555C80.3455 26.8555 81.7993 28.3092 81.7993 30.1025Z"
      fill="url(#paint40_linear_8514_64335)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M84.1919 50.9357C89.3858 48.7368 93.0298 43.5928 93.0298 37.5977C93.0298 29.6019 86.548 23.1201 78.5522 23.1201C70.5564 23.1201 64.0747 29.6019 64.0747 37.5977C64.0747 43.6116 67.7415 48.769 72.9614 50.9562V59.836C72.9614 60.4847 73.2136 61.108 73.6646 61.5742L74.9725 62.9263C75.3958 63.3637 75.6226 63.9545 75.6008 64.5626C75.5833 65.0537 75.4045 65.5254 75.0923 65.9049L74.4684 66.6632C74.1571 67.0416 73.9868 67.5165 73.9868 68.0065C73.9868 68.4877 74.151 68.9545 74.4522 69.3298L75.0624 70.0903C75.3933 70.5027 75.5737 71.0158 75.5737 71.5446C75.5737 72.1912 75.3044 72.8085 74.8304 73.2482L73.7611 74.2402C73.2512 74.7133 72.9614 75.3774 72.9614 76.073V80.8594C72.9614 83.9606 75.4755 86.4746 78.5767 86.4746C81.6778 86.4746 84.1919 83.9606 84.1919 80.8594V50.9357ZM81.7993 30.1025C81.7993 31.8959 80.3455 33.3496 78.5522 33.3496C76.759 33.3496 75.3052 31.8959 75.3052 30.1025C75.3052 28.3092 76.759 26.8555 78.5522 26.8555C80.3455 26.8555 81.7993 28.3092 81.7993 30.1025Z"
      fill="url(#paint41_radial_8514_64335)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M84.1919 50.9357C89.3858 48.7368 93.0298 43.5928 93.0298 37.5977C93.0298 29.6019 86.548 23.1201 78.5522 23.1201C70.5564 23.1201 64.0747 29.6019 64.0747 37.5977C64.0747 43.6116 67.7415 48.769 72.9614 50.9562V59.836C72.9614 60.4847 73.2136 61.108 73.6646 61.5742L74.9725 62.9263C75.3958 63.3637 75.6226 63.9545 75.6008 64.5626C75.5833 65.0537 75.4045 65.5254 75.0923 65.9049L74.4684 66.6632C74.1571 67.0416 73.9868 67.5165 73.9868 68.0065C73.9868 68.4877 74.151 68.9545 74.4522 69.3298L75.0624 70.0903C75.3933 70.5027 75.5737 71.0158 75.5737 71.5446C75.5737 72.1912 75.3044 72.8085 74.8304 73.2482L73.7611 74.2402C73.2512 74.7133 72.9614 75.3774 72.9614 76.073V80.8594C72.9614 83.9606 75.4755 86.4746 78.5767 86.4746C81.6778 86.4746 84.1919 83.9606 84.1919 80.8594V50.9357ZM81.7993 30.1025C81.7993 31.8959 80.3455 33.3496 78.5522 33.3496C76.759 33.3496 75.3052 31.8959 75.3052 30.1025C75.3052 28.3092 76.759 26.8555 78.5522 26.8555C80.3455 26.8555 81.7993 28.3092 81.7993 30.1025Z"
      fill="url(#paint42_radial_8514_64335)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M84.1919 50.9357C89.3858 48.7368 93.0298 43.5928 93.0298 37.5977C93.0298 29.6019 86.548 23.1201 78.5522 23.1201C70.5564 23.1201 64.0747 29.6019 64.0747 37.5977C64.0747 43.6116 67.7415 48.769 72.9614 50.9562V59.836C72.9614 60.4847 73.2136 61.108 73.6646 61.5742L74.9725 62.9263C75.3958 63.3637 75.6226 63.9545 75.6008 64.5626C75.5833 65.0537 75.4045 65.5254 75.0923 65.9049L74.4684 66.6632C74.1571 67.0416 73.9868 67.5165 73.9868 68.0065C73.9868 68.4877 74.151 68.9545 74.4522 69.3298L75.0624 70.0903C75.3933 70.5027 75.5737 71.0158 75.5737 71.5446C75.5737 72.1912 75.3044 72.8085 74.8304 73.2482L73.7611 74.2402C73.2512 74.7133 72.9614 75.3774 72.9614 76.073V80.8594C72.9614 83.9606 75.4755 86.4746 78.5767 86.4746C81.6778 86.4746 84.1919 83.9606 84.1919 80.8594V50.9357ZM81.7993 30.1025C81.7993 31.8959 80.3455 33.3496 78.5522 33.3496C76.759 33.3496 75.3052 31.8959 75.3052 30.1025C75.3052 28.3092 76.759 26.8555 78.5522 26.8555C80.3455 26.8555 81.7993 28.3092 81.7993 30.1025Z"
      fill="url(#paint43_radial_8514_64335)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M84.1919 50.9357C89.3858 48.7368 93.0298 43.5928 93.0298 37.5977C93.0298 29.6019 86.548 23.1201 78.5522 23.1201C70.5564 23.1201 64.0747 29.6019 64.0747 37.5977C64.0747 43.6116 67.7415 48.769 72.9614 50.9562V59.836C72.9614 60.4847 73.2136 61.108 73.6646 61.5742L74.9725 62.9263C75.3958 63.3637 75.6226 63.9545 75.6008 64.5626C75.5833 65.0537 75.4045 65.5254 75.0923 65.9049L74.4684 66.6632C74.1571 67.0416 73.9868 67.5165 73.9868 68.0065C73.9868 68.4877 74.151 68.9545 74.4522 69.3298L75.0624 70.0903C75.3933 70.5027 75.5737 71.0158 75.5737 71.5446C75.5737 72.1912 75.3044 72.8085 74.8304 73.2482L73.7611 74.2402C73.2512 74.7133 72.9614 75.3774 72.9614 76.073V80.8594C72.9614 83.9606 75.4755 86.4746 78.5767 86.4746C81.6778 86.4746 84.1919 83.9606 84.1919 80.8594V50.9357ZM81.7993 30.1025C81.7993 31.8959 80.3455 33.3496 78.5522 33.3496C76.759 33.3496 75.3052 31.8959 75.3052 30.1025C75.3052 28.3092 76.759 26.8555 78.5522 26.8555C80.3455 26.8555 81.7993 28.3092 81.7993 30.1025Z"
      fill="url(#paint44_radial_8514_64335)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M84.1919 50.9357C89.3858 48.7368 93.0298 43.5928 93.0298 37.5977C93.0298 29.6019 86.548 23.1201 78.5522 23.1201C70.5564 23.1201 64.0747 29.6019 64.0747 37.5977C64.0747 43.6116 67.7415 48.769 72.9614 50.9562V59.836C72.9614 60.4847 73.2136 61.108 73.6646 61.5742L74.9725 62.9263C75.3958 63.3637 75.6226 63.9545 75.6008 64.5626C75.5833 65.0537 75.4045 65.5254 75.0923 65.9049L74.4684 66.6632C74.1571 67.0416 73.9868 67.5165 73.9868 68.0065C73.9868 68.4877 74.151 68.9545 74.4522 69.3298L75.0624 70.0903C75.3933 70.5027 75.5737 71.0158 75.5737 71.5446C75.5737 72.1912 75.3044 72.8085 74.8304 73.2482L73.7611 74.2402C73.2512 74.7133 72.9614 75.3774 72.9614 76.073V80.8594C72.9614 83.9606 75.4755 86.4746 78.5767 86.4746C81.6778 86.4746 84.1919 83.9606 84.1919 80.8594V50.9357ZM81.7993 30.1025C81.7993 31.8959 80.3455 33.3496 78.5522 33.3496C76.759 33.3496 75.3052 31.8959 75.3052 30.1025C75.3052 28.3092 76.759 26.8555 78.5522 26.8555C80.3455 26.8555 81.7993 28.3092 81.7993 30.1025Z"
      fill="url(#paint45_radial_8514_64335)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M84.1919 50.9357C89.3858 48.7368 93.0298 43.5928 93.0298 37.5977C93.0298 29.6019 86.548 23.1201 78.5522 23.1201C70.5564 23.1201 64.0747 29.6019 64.0747 37.5977C64.0747 43.6116 67.7415 48.769 72.9614 50.9562V59.836C72.9614 60.4847 73.2136 61.108 73.6646 61.5742L74.9725 62.9263C75.3958 63.3637 75.6226 63.9545 75.6008 64.5626C75.5833 65.0537 75.4045 65.5254 75.0923 65.9049L74.4684 66.6632C74.1571 67.0416 73.9868 67.5165 73.9868 68.0065C73.9868 68.4877 74.151 68.9545 74.4522 69.3298L75.0624 70.0903C75.3933 70.5027 75.5737 71.0158 75.5737 71.5446C75.5737 72.1912 75.3044 72.8085 74.8304 73.2482L73.7611 74.2402C73.2512 74.7133 72.9614 75.3774 72.9614 76.073V80.8594C72.9614 83.9606 75.4755 86.4746 78.5767 86.4746C81.6778 86.4746 84.1919 83.9606 84.1919 80.8594V50.9357ZM81.7993 30.1025C81.7993 31.8959 80.3455 33.3496 78.5522 33.3496C76.759 33.3496 75.3052 31.8959 75.3052 30.1025C75.3052 28.3092 76.759 26.8555 78.5522 26.8555C80.3455 26.8555 81.7993 28.3092 81.7993 30.1025Z"
      fill="url(#paint46_radial_8514_64335)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M84.1919 50.9357C89.3858 48.7368 93.0298 43.5928 93.0298 37.5977C93.0298 29.6019 86.548 23.1201 78.5522 23.1201C70.5564 23.1201 64.0747 29.6019 64.0747 37.5977C64.0747 43.6116 67.7415 48.769 72.9614 50.9562V59.836C72.9614 60.4847 73.2136 61.108 73.6646 61.5742L74.9725 62.9263C75.3958 63.3637 75.6226 63.9545 75.6008 64.5626C75.5833 65.0537 75.4045 65.5254 75.0923 65.9049L74.4684 66.6632C74.1571 67.0416 73.9868 67.5165 73.9868 68.0065C73.9868 68.4877 74.151 68.9545 74.4522 69.3298L75.0624 70.0903C75.3933 70.5027 75.5737 71.0158 75.5737 71.5446C75.5737 72.1912 75.3044 72.8085 74.8304 73.2482L73.7611 74.2402C73.2512 74.7133 72.9614 75.3774 72.9614 76.073V80.8594C72.9614 83.9606 75.4755 86.4746 78.5767 86.4746C81.6778 86.4746 84.1919 83.9606 84.1919 80.8594V50.9357ZM81.7993 30.1025C81.7993 31.8959 80.3455 33.3496 78.5522 33.3496C76.759 33.3496 75.3052 31.8959 75.3052 30.1025C75.3052 28.3092 76.759 26.8555 78.5522 26.8555C80.3455 26.8555 81.7993 28.3092 81.7993 30.1025Z"
      fill="url(#paint47_radial_8514_64335)"
      fill-opacity="0.6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M84.1919 50.9357C89.3858 48.7368 93.0298 43.5928 93.0298 37.5977C93.0298 29.6019 86.548 23.1201 78.5522 23.1201C70.5564 23.1201 64.0747 29.6019 64.0747 37.5977C64.0747 43.6116 67.7415 48.769 72.9614 50.9562V59.836C72.9614 60.4847 73.2136 61.108 73.6646 61.5742L74.9725 62.9263C75.3958 63.3637 75.6226 63.9545 75.6008 64.5626C75.5833 65.0537 75.4045 65.5254 75.0923 65.9049L74.4684 66.6632C74.1571 67.0416 73.9868 67.5165 73.9868 68.0065C73.9868 68.4877 74.151 68.9545 74.4522 69.3298L75.0624 70.0903C75.3933 70.5027 75.5737 71.0158 75.5737 71.5446C75.5737 72.1912 75.3044 72.8085 74.8304 73.2482L73.7611 74.2402C73.2512 74.7133 72.9614 75.3774 72.9614 76.073V80.8594C72.9614 83.9606 75.4755 86.4746 78.5767 86.4746C81.6778 86.4746 84.1919 83.9606 84.1919 80.8594V50.9357ZM81.7993 30.1025C81.7993 31.8959 80.3455 33.3496 78.5522 33.3496C76.759 33.3496 75.3052 31.8959 75.3052 30.1025C75.3052 28.3092 76.759 26.8555 78.5522 26.8555C80.3455 26.8555 81.7993 28.3092 81.7993 30.1025Z"
      fill="url(#paint48_radial_8514_64335)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M84.1919 50.9357C89.3858 48.7368 93.0298 43.5928 93.0298 37.5977C93.0298 29.6019 86.548 23.1201 78.5522 23.1201C70.5564 23.1201 64.0747 29.6019 64.0747 37.5977C64.0747 43.6116 67.7415 48.769 72.9614 50.9562V59.836C72.9614 60.4847 73.2136 61.108 73.6646 61.5742L74.9725 62.9263C75.3958 63.3637 75.6226 63.9545 75.6008 64.5626C75.5833 65.0537 75.4045 65.5254 75.0923 65.9049L74.4684 66.6632C74.1571 67.0416 73.9868 67.5165 73.9868 68.0065C73.9868 68.4877 74.151 68.9545 74.4522 69.3298L75.0624 70.0903C75.3933 70.5027 75.5737 71.0158 75.5737 71.5446C75.5737 72.1912 75.3044 72.8085 74.8304 73.2482L73.7611 74.2402C73.2512 74.7133 72.9614 75.3774 72.9614 76.073V80.8594C72.9614 83.9606 75.4755 86.4746 78.5767 86.4746C81.6778 86.4746 84.1919 83.9606 84.1919 80.8594V50.9357ZM81.7993 30.1025C81.7993 31.8959 80.3455 33.3496 78.5522 33.3496C76.759 33.3496 75.3052 31.8959 75.3052 30.1025C75.3052 28.3092 76.759 26.8555 78.5522 26.8555C80.3455 26.8555 81.7993 28.3092 81.7993 30.1025Z"
      fill="url(#paint49_radial_8514_64335)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M84.1919 50.9357C89.3858 48.7368 93.0298 43.5928 93.0298 37.5977C93.0298 29.6019 86.548 23.1201 78.5522 23.1201C70.5564 23.1201 64.0747 29.6019 64.0747 37.5977C64.0747 43.6116 67.7415 48.769 72.9614 50.9562V59.836C72.9614 60.4847 73.2136 61.108 73.6646 61.5742L74.9725 62.9263C75.3958 63.3637 75.6226 63.9545 75.6008 64.5626C75.5833 65.0537 75.4045 65.5254 75.0923 65.9049L74.4684 66.6632C74.1571 67.0416 73.9868 67.5165 73.9868 68.0065C73.9868 68.4877 74.151 68.9545 74.4522 69.3298L75.0624 70.0903C75.3933 70.5027 75.5737 71.0158 75.5737 71.5446C75.5737 72.1912 75.3044 72.8085 74.8304 73.2482L73.7611 74.2402C73.2512 74.7133 72.9614 75.3774 72.9614 76.073V80.8594C72.9614 83.9606 75.4755 86.4746 78.5767 86.4746C81.6778 86.4746 84.1919 83.9606 84.1919 80.8594V50.9357ZM81.7993 30.1025C81.7993 31.8959 80.3455 33.3496 78.5522 33.3496C76.759 33.3496 75.3052 31.8959 75.3052 30.1025C75.3052 28.3092 76.759 26.8555 78.5522 26.8555C80.3455 26.8555 81.7993 28.3092 81.7993 30.1025Z"
      fill="url(#paint50_radial_8514_64335)"
      fill-opacity="0.69"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M84.1919 50.9357C89.3858 48.7368 93.0298 43.5928 93.0298 37.5977C93.0298 29.6019 86.548 23.1201 78.5522 23.1201C70.5564 23.1201 64.0747 29.6019 64.0747 37.5977C64.0747 43.6116 67.7415 48.769 72.9614 50.9562V59.836C72.9614 60.4847 73.2136 61.108 73.6646 61.5742L74.9725 62.9263C75.3958 63.3637 75.6226 63.9545 75.6008 64.5626C75.5833 65.0537 75.4045 65.5254 75.0923 65.9049L74.4684 66.6632C74.1571 67.0416 73.9868 67.5165 73.9868 68.0065C73.9868 68.4877 74.151 68.9545 74.4522 69.3298L75.0624 70.0903C75.3933 70.5027 75.5737 71.0158 75.5737 71.5446C75.5737 72.1912 75.3044 72.8085 74.8304 73.2482L73.7611 74.2402C73.2512 74.7133 72.9614 75.3774 72.9614 76.073V80.8594C72.9614 83.9606 75.4755 86.4746 78.5767 86.4746C81.6778 86.4746 84.1919 83.9606 84.1919 80.8594V50.9357ZM81.7993 30.1025C81.7993 31.8959 80.3455 33.3496 78.5522 33.3496C76.759 33.3496 75.3052 31.8959 75.3052 30.1025C75.3052 28.3092 76.759 26.8555 78.5522 26.8555C80.3455 26.8555 81.7993 28.3092 81.7993 30.1025Z"
      fill="url(#paint51_radial_8514_64335)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_8514_64335"
        x1="20.5528"
        y1="27.5381"
        x2="30.4166"
        y2="27.5381"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8F8E93" />
        <stop
          offset="1"
          stop-color="#8F8E93"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_8514_64335"
        x1="31.8588"
        y1="6.18298"
        x2="36.9867"
        y2="11.0098"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8F8E93" />
        <stop
          offset="1"
          stop-color="#8F8E93"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_8514_64335"
        x1="46.6016"
        y1="5.86248"
        x2="47.2425"
        y2="11.0098"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8F8E93" />
        <stop
          offset="1"
          stop-color="#8F8E93"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint3_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(47.7896 30.3228) rotate(82.9768) scale(13.8475)"
      >
        <stop
          offset="0.598958"
          stop-color="#8F8E93"
        />
        <stop
          offset="1"
          stop-color="#8F8E93"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint4_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(43.5547 23.8027) rotate(-90) scale(15.1367 16.5268)"
      >
        <stop
          offset="0.530612"
          stop-color="#AB83C0"
        />
        <stop
          offset="1"
          stop-color="#CBBBDC"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint5_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(28.7254 28.6977) rotate(180) scale(4.45054 15.5976)"
      >
        <stop stop-color="#EDECF3" />
        <stop
          offset="0.677083"
          stop-color="#EDECF3"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint6_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(56.8338 16.7022) rotate(-35.8528) scale(3.26551 11.9059)"
      >
        <stop stop-color="#EDECF3" />
        <stop
          offset="0.677083"
          stop-color="#EDECF3"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint7_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(53.0855 13.4264) rotate(-53.0623) scale(3.07568 7.60134)"
      >
        <stop stop-color="#EDECF3" />
        <stop
          offset="0.677083"
          stop-color="#EDECF3"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint8_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(48.0728 11.2209) rotate(-61.8969) scale(3.03153 7.60631)"
      >
        <stop stop-color="#EDECF3" />
        <stop
          offset="0.677083"
          stop-color="#EDECF3"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint9_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(59.4805 23.5885) rotate(-13.351) scale(2.89987 6.70802)"
      >
        <stop stop-color="#EDECF3" />
        <stop
          offset="0.677083"
          stop-color="#EDECF3"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint10_linear_8514_64335"
        x1="25.3906"
        y1="44.2129"
        x2="47.0703"
        y2="93.5293"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFC74E" />
        <stop
          offset="1"
          stop-color="#F7864E"
        />
      </linearGradient>
      <radialGradient
        id="paint11_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(76.1719 93.5293) rotate(-132.274) scale(10.1623 23.6749)"
      >
        <stop stop-color="#FF8650" />
        <stop
          offset="1"
          stop-color="#FF8650"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint12_linear_8514_64335"
        x1="43.6523"
        y1="33.666"
        x2="43.6523"
        y2="38.3535"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F3D04E" />
        <stop
          offset="1"
          stop-color="#F3D04E"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint13_linear_8514_64335"
        x1="43.6523"
        y1="34.6426"
        x2="43.6523"
        y2="37.4417"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFD744" />
        <stop
          offset="1"
          stop-color="#FFD744"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint14_linear_8514_64335"
        x1="13.7045"
        y1="34.6426"
        x2="17.8641"
        y2="39.1089"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFD744" />
        <stop
          offset="1"
          stop-color="#FFD744"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint15_linear_8514_64335"
        x1="76.0363"
        y1="34.6426"
        x2="72.7383"
        y2="38.7753"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFD744" />
        <stop
          offset="1"
          stop-color="#FFD744"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint16_linear_8514_64335"
        x1="9.375"
        y1="62.3803"
        x2="13.9503"
        y2="62.3803"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#BA7A35" />
        <stop
          offset="1"
          stop-color="#BA7A35"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint17_linear_8514_64335"
        x1="10.9965"
        y1="34.6426"
        x2="15.7225"
        y2="37.8642"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#BA7A35" />
        <stop
          offset="1"
          stop-color="#BA7A35"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint18_linear_8514_64335"
        x1="9.375"
        y1="91.3271"
        x2="13.4899"
        y2="86.5726"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#BA7A35" />
        <stop
          offset="1"
          stop-color="#BA7A35"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint19_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(76.9531 34.6426) rotate(126.254) scale(7.26605 16.4116)"
      >
        <stop stop-color="#FFF760" />
        <stop
          offset="1"
          stop-color="#FFF760"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint20_linear_8514_64335"
        x1="43.6523"
        y1="94.6942"
        x2="43.6523"
        y2="89.0821"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E55D6C" />
        <stop
          offset="1"
          stop-color="#E55D6C"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint21_linear_8514_64335"
        x1="9.375"
        y1="93.5293"
        x2="15.6318"
        y2="88.6849"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.260417"
          stop-color="#E55E5D"
        />
        <stop
          offset="1"
          stop-color="#E55D6C"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint22_linear_8514_64335"
        x1="7.53847"
        y1="63.0954"
        x2="11.8006"
        y2="63.0954"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E55E5D" />
        <stop
          offset="1"
          stop-color="#E55D6C"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint23_linear_8514_64335"
        x1="82.1407"
        y1="63.0954"
        x2="75.6222"
        y2="63.0954"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E55D72" />
        <stop
          offset="1"
          stop-color="#E55D6C"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint24_linear_8514_64335"
        x1="78.4712"
        y1="64.0859"
        x2="73.1146"
        y2="64.0859"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.291667"
          stop-color="#FFC55D"
        />
        <stop
          offset="1"
          stop-color="#FFC55D"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint25_linear_8514_64335"
        x1="77.9297"
        y1="91.812"
        x2="73.753"
        y2="87.9084"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFB95D" />
        <stop
          offset="1"
          stop-color="#FFC55D"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint26_linear_8514_64335"
        x1="76.659"
        y1="38.1011"
        x2="73.2896"
        y2="40.302"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFB95D" />
        <stop
          offset="1"
          stop-color="#FFC55D"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint27_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(44.6339 57.2818) rotate(95.6522) scale(10.3994 9.68737)"
      >
        <stop
          offset="0.765625"
          stop-color="#D98A40"
        />
        <stop
          offset="1"
          stop-color="#D98A40"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint28_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(45.6504 69.9546) rotate(-87.6141) scale(9.66016 5.03382)"
      >
        <stop
          offset="0.765625"
          stop-color="#D98A40"
        />
        <stop
          offset="1"
          stop-color="#D98A40"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint29_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(40.7071 55.6845) rotate(43.1524) scale(8.89295)"
      >
        <stop
          offset="0.677083"
          stop-color="#FFCD63"
        />
        <stop
          offset="1"
          stop-color="#FFCD63"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint30_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(41.2908 68.9051) rotate(-90.507) scale(11.1918 4.90022)"
      >
        <stop stop-color="#FFCD63" />
        <stop
          offset="0.0260417"
          stop-color="#FFCD63"
        />
        <stop
          offset="1"
          stop-color="#FFCD63"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint31_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(35.4614 58.2757) rotate(34.0609) scale(17.785 24.46)"
      >
        <stop
          offset="0.21669"
          stop-color="#564F80"
        />
        <stop
          offset="1"
          stop-color="#473154"
        />
      </radialGradient>
      <radialGradient
        id="paint32_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(70.6198 38.9708) rotate(71.5651) scale(15.0424 11.7781)"
      >
        <stop
          offset="0.104167"
          stop-color="#763616"
        />
        <stop
          offset="1"
          stop-color="#763C16"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint33_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(77.5529 53.7127) rotate(-149.758) scale(9.80685 6.89698)"
      >
        <stop
          stop-color="#763C16"
          stop-opacity="0.26"
        />
        <stop
          offset="1"
          stop-color="#763C16"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint34_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(74.3614 51.2764) rotate(87.5239) scale(18.6496 7.65595)"
      >
        <stop stop-color="#763C16" />
        <stop
          offset="1"
          stop-color="#763C16"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint35_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(81.9008 63.0344) rotate(-118.185) scale(14.6917 9.06277)"
      >
        <stop stop-color="#763C16" />
        <stop
          offset="1"
          stop-color="#763C16"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint36_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(80.6446 76.1512) rotate(-104.886) scale(18.1108 11.1719)"
      >
        <stop
          offset="0.119792"
          stop-color="#763C16"
        />
        <stop
          offset="1"
          stop-color="#763C16"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint37_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(79.4261 52.9985) rotate(121.293) scale(6.61152 4.0784)"
      >
        <stop
          offset="0.864583"
          stop-color="#763C16"
        />
        <stop
          offset="1"
          stop-color="#763C16"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint38_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(75.2562 77.0275) rotate(88.2706) scale(10.191 7.53557)"
      >
        <stop stop-color="#BC553E" />
        <stop
          offset="1"
          stop-color="#BC553E"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint39_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(76.0007 81.6887) rotate(37.2348) scale(6.75089 6.50853)"
      >
        <stop stop-color="#BC553E" />
        <stop
          offset="1"
          stop-color="#BC553E"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint40_linear_8514_64335"
        x1="72.8157"
        y1="67.3896"
        x2="81.7683"
        y2="67.3896"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A390B1" />
        <stop
          offset="0.300971"
          stop-color="#A390B1"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint41_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(72.5923 64.51) scale(6.35477)"
      >
        <stop
          offset="0.295337"
          stop-color="#A390B1"
        />
        <stop
          offset="0.755388"
          stop-color="#A390B1"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint42_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(72.7051 71.582) rotate(0.84875) scale(6.59252)"
      >
        <stop
          offset="0.295337"
          stop-color="#A390B1"
        />
        <stop
          offset="0.755388"
          stop-color="#A390B1"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint43_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(78.5522 37.4025) rotate(90) scale(15.1891)"
      >
        <stop
          offset="0.847888"
          stop-color="#CDC1DE"
        />
        <stop
          offset="0.963852"
          stop-color="#A390B1"
        />
        <stop
          offset="1"
          stop-color="#A390B1"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint44_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(85.8398 44.043) rotate(90) scale(23.4375 14.1602)"
      >
        <stop
          offset="0.820833"
          stop-color="#CDC1DE"
        />
        <stop
          offset="1"
          stop-color="#CDC1DE"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint45_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(79.6875 36.4258) rotate(95.3558) scale(12.1625 12.1625)"
      >
        <stop
          offset="0.727261"
          stop-color="#FFFFFF"
          stop-opacity="0"
        />
        <stop
          offset="0.906268"
          stop-color="#FFFFFF"
          stop-opacity="0.3"
        />
        <stop
          offset="1"
          stop-color="#FFFFFF"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint46_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(78.5522 38.623) rotate(93.2721) scale(12.6182 13.5573)"
      >
        <stop
          offset="0.820833"
          stop-color="#CDC1DE"
        />
        <stop
          offset="1"
          stop-color="#CDC1DE"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint47_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(86.0352 84.8633) rotate(-93.2987) scale(33.943 4.88596)"
      >
        <stop stop-color="#FFFFFF" />
        <stop
          offset="1"
          stop-color="#FFFFFF"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint48_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(78.5522 47.7539) rotate(90) scale(40.2344 20.9351)"
      >
        <stop
          offset="0.912621"
          stop-color="#BA85E6"
          stop-opacity="0"
        />
        <stop
          offset="0.973301"
          stop-color="#BA85E6"
        />
      </radialGradient>
      <radialGradient
        id="paint49_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(80.5763 29.8312) rotate(-120.292) scale(4.01274 3.33763)"
      >
        <stop
          offset="0.328125"
          stop-color="#AF87C8"
        />
        <stop
          offset="1"
          stop-color="#AF87C8"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint50_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(79.8663 32.1252) rotate(-135) scale(5.2891)"
      >
        <stop stop-color="#96919B" />
        <stop
          offset="0.770833"
          stop-color="#96919B"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint51_radial_8514_64335"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(77.4563 31.5039) rotate(-135) scale(3.8142)"
      >
        <stop
          offset="0.166667"
          stop-color="#E5E2ED"
        />
        <stop
          offset="1"
          stop-color="#E5E2ED"
          stop-opacity="0"
        />
      </radialGradient>
    </defs>
  </svg>
</template>
